import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withStyles from '@material-ui/core/styles/withStyles';
import ReportDataAccess from '../services/reportDataAccess';
import ScheduleDataAccess from '../services/scheduleDataAccess';
import UserDataAccess from '../services/userDataAccess';
import RichTextEditor from './RichTextEditor';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IntegrationAutosuggest from './IntegrationAutosuggest';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import Auth from '../services/auth';
import CircularProgress from '@material-ui/core/CircularProgress';
import SaveIcon from '@material-ui/icons/Save';
import MoreIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import PubSub from 'pubsub-js';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { InputLabel, NativeSelect, FormHelperText, FormControl, Card, CardHeader, CardContent } from '@material-ui/core';
import 'react-datepicker/dist/react-datepicker.css';
import { withRouter } from "react-router-dom";
import compose from 'recompose/compose';
import ProgressIndicator from './ProgressIndicator';
import ReactGA from 'react-ga4';
import Fab from '@material-ui/core/Fab';
import esignDoc from '../docs/E-SignatureForms.pdf';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Alert from './Alert';
import SettingsDataAccess from '../services/settingsDataAccess';

const dataAccess = new ReportDataAccess();
const scheduleAccess = new ScheduleDataAccess();
const settingsDataAccess = new SettingsDataAccess();
const userDataAccess = new UserDataAccess();
const auth = new Auth();

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    paper: {
        padding: theme.spacing(1),
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '100%',
    }
    ,
    textFieldSm: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '50%',
    }, container: {
        position: 'relative',
    },
    distButton: {
        marginTop: theme.spacing(1)
    },
    warning: {
        color: 'red'
    },
    fab: {
        position: 'fixed',
        bottom: theme.spacing(10),
        right: theme.spacing(4),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    iconSmall: {
        fontSize: 20,
        marginLeft: theme.spacing(1),
    },
    issueSnack: {
        backgroundColor: theme.palette.secondary.main,
        maxWidth: '100%'
    },
    issueSnackButton: {
        color: theme.palette.secondary.contrastText,
    },
    heading: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
    },
    addendumSnack: {
        backgroundColor: theme.palette.secondary.main,
        maxWidth: '100%',
    },
    datePicker: {
        width: '100%',
        '& .react-datepicker__input-container': {
            width: '100%'
        },
        '& .react-datepicker-wrapper': {
            width: '100%'
        }
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {

        position: 'relative',
    },
});


class DocumentRequest {
    ReportId;
    DocumentAsBase64String;
    PatientInfo;
}



class ReportDetails extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            showProgressIndicator: true,
            showAlert: false,
            progressTitle: "Loading Report...",
            progressText: "",
            anchorEl: null,
            anchorElExtended: null,
            open: false,
            openAudit: false,
            openDistHist: false,
            distributionName: '',
            distributionAddress: '',
            distributionSaveAddress: false,
            suggestions: [],
            report: '',
            patient: {
                Account: "",
                AdmitDate: "",
                Archived: false,
                CaseId: "",
                Comments: "",
                Complete: "",
                DateOfBirth: "",
                DateOfService: "",
                DictatorId: "",
                Downloaded: false,
                ESigTime: "",
                ESigned: false,
                Id: 0,
                JobId: "",
                Location: "",
                Name: "",
                PatientFirstName: "",
                PatientID: "",
                PatientInfoId: 0,
                PatientLastName: "",
                Physician: "",
                Printed: false,
                Procedure: "",
                Read: false,
                ReferringPhysician: "",
                WorkType: "OP",
                OverallStatus: "",
                HasValidSignature: false,
                ParentJobId: 0,
                ChildJobs: [],
            },
            patientIdInvalid: false,
            auditDetails: null,
            distHistory: null,
            openSnack: false,
            snackMessage: "",
            showWarning: false,
            warningTitle: "",
            warningText: "",
            showSignWarning: false,
            confirmedSign: false,
            loadingAudit: false,
            loadingDistribution: false,
            reportHtml: '',
            reportChanged: false,
            sendingDistribution: false,
            scheduleDate: moment(),
            scheduleDateInput: '',
            reassignPatient: false,
            selectedNewPatient: '',
            reassignPatientList: [],
            loadingResassignPatients: true,
            editPatientData: false,
            selectedJobs:  (props.history.location.state) ? (props.history.location.state.selectedJobs || []) : [],
            font: "Courier New",
            fontSize: "12pt",
            reportMode: "",
            alert: {
                alertText: "",
                alertOkText: "",
                alertCancelText: "",
                alertTitle: "",
                onAlertOk: () => { },
                onAlertCancel: () => this.setState({ showAlert: false }),
                component: null

            },
            unlockSignature: false,
        };

    }

    createAddendum = () => {
        this.loadReportDetail();
    }

    loadReport = () => {
        let self = this;
        this.loadReportDetail();
    }

    componentWillMount() {

        this.loadReport();

        this.token = PubSub.subscribe('AccountChanged', this.accountChanged.bind(this));
      
    }
    componentDidUpdate(prevProps, prevState) {

        if (prevProps.match.params.jobid !== this.props.match.params.jobid) {
            this.setState({ report: '' });
            this.loadReport();
        }
    }
    componentWillUnmount() {
        PubSub.unsubscribe(this.token);
    }

    loadReportDetail = async () => {

        var { data: childJobs } = await dataAccess.getChildJobs(this.props.match.params.account, this.props.match.params.jobid);

        let self = this;
        self.setState({ showProgressIndicator: true, progressTitle: "Loading Report..." });

        dataAccess.getReportDetailById(this.props.match.params.jobid, this.props.match.params.account).then(
            function (patientData) {
                patientData.ChildJobs = childJobs;

                self.setState({ patient: patientData, scheduleDate: moment(patientData.DateOfService), scheduleDateInput: moment(patientData.DateOfService).format('MM/DD/YYYY') });

                settingsDataAccess.getAccountSettingsBySettingsNameRcm("UnlockSignature")
                    .then(result => {
                        if (result.data.SettingValue === "true") {
                            self.setState({ unlockSignature: true });
                        }
                    })
                    .catch(error => {
                    })
                if (patientData.Comments && patientData.Comments.length > 0 && patientData.Comments !== "STAT REQUESTED") {
                    self.setState({
                        showWarning: true,
                        warningTitle: "Completed with Questions",
                        warningText: `Please address the following comment: \n\n
                                      ${patientData.Comments}`
                    });
                }

                self.loadReportDoc().then(() => {

                    userDataAccess.writeAudit({
                        JobId: patientData.JobId,
                        Message: `USER VIEWED DOCUMENT ONLINE: ${auth.getUserId()}`
                    });

                    self.setState({ showProgressIndicator: false });
                });

              

            }).catch(error => {
                self.setState({ showProgressIndicator: false, openSnack: true, snackMessage: "Report Not Found" });
            });

        dataAccess.getDistributionAddresses(this.props.match.params.account).then(function (suggestions) {

            self.setState({ suggestions });

        });
    }
    accountChanged(msg, data) {
        this.props.history.push("/");
    }

    onOpenMenu = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    }

    checkNextReport = () => {
        
        return (this.state.selectedJobs.length > 1);

    }

    navigateNext = (event, remove) => {


        let reportsForReview = this.state.selectedJobs;
        if (reportsForReview.length > 0) {
            let index = this.state.selectedJobs.indexOf(parseInt(this.props.match.params.jobid, 10));
          
            if (index > -1) {

              

                if (reportsForReview.length > 0) {
                    let ndx = index + 1;

                    if (ndx >= reportsForReview.length) {
                        ndx = 0;
                    }


                    let path = `/reportDetails/${auth.getActiveAccount()}/${this.state.selectedJobs[ndx]}`;
                 
                    this.props.history.push({
                        pathname: path,
                        state: { selectedJobs: reportsForReview }
                    });

                    if (remove) {
                        reportsForReview.splice(index, 1);
                        this.setState({ selectedJobs: reportsForReview });
                    }
                }
            }
        }
    }

    onCloseMenu = (event) => {
        this.setState({ anchorEl: null });
    }

    onOpenMenuExtended = (event) => {
        this.setState({ anchorElExtended: event.currentTarget });
    }

    onCloseMenuExtended = (event) => {
        this.setState({ anchorElExtended: null });
    }

    onSuggestionSelected = (selectedItem) => {

        this.setState({ distributionAddress: selectedItem.Address });
    }

    onSuggestedInputChanged = (selectedName) => {

        this.setState({ distributionName: selectedName });

    }

    onSelectDownloadOption = (event, downloadType) => {

        var self = this;
        let jobName = `${this.state.patient.Name}-${this.state.patient.JobId}_${this.props.match.params.jobid}`;
        dataAccess.getReportForViewById(this.props.match.params.account, this.props.match.params.jobid, downloadType).then(
            function (reportData) {

                var byteNumbers = new Array(reportData.length);
                for (var i = 0; i < reportData.length; i++) {
                    byteNumbers[i] = reportData.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                let blobType = "application/pdf;charset=utf-8";
                if (downloadType === "Doc") {
                    blobType = "application/msword;charset=utf-8";
                }
                let fileName = `${jobName}__SNMDP229.${downloadType}`;
                const blob = new Blob([byteArray], { type: blobType });
                if (navigator.msSaveBlob) {
                    navigator.msSaveBlob(blob, fileName);
                } else {
                    var link = document.createElement("a");
                    if (link.download !== undefined) {
                        var url = URL.createObjectURL(blob);
                        link.setAttribute('href', url);
                        link.setAttribute('download', fileName);
                        link.style.visibility = 'hidden';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }

                self.setState({ openSnack: true, snackMessage: "Report downloaded" });

            });

        this.setState({ anchorEl: null });
    }

    handleClose = () => {
        this.setState({
            open: false,
        });
    };

    handleClick = () => {
        this.setState({
            open: true,

        });
    };

    handleDownload = () => {
        alert('not implemented')
    };

    handleGoToParent = () => {
        console.log('gotoparent');
        dataAccess.getParentId(this.props.match.params.account, this.props.match.params.jobid.trim()).then((result) => {
            let parentJobId = result.data.ParentJobId;

            if (parentJobId === void(0) || parentJobId == 0)
                return alert('no job found');

            this.props.history.push({
                pathname: `/reportDetails/${this.state.patient.Account}/${parentJobId}`
            });
        }).then(error => {});
    };

    handleGotToAddendum = (event, reportId) => {
        this.props.history.push({
            pathname: `/reportDetails/${this.state.patient.Account}/${reportId}`
        });
    }
    handleEditorChange = (report) => {

        var hasChange = this.state.reportChanged;
        if (this.state.reportHtml !== '' && !this.state.reportChanged) {
            hasChange =  this.state.reportHtml !== report;
        }
        this.setState({ reportHtml: report, reportChanged: hasChange });
        PubSub.publish('IdleReset');
    }

    buildDocumentRequest = (updatePatientInfo) => {

        let self = this;

        let safeHtml = unescape(encodeURIComponent(self.state.reportHtml));
        const reportSnippet = safeHtml.replace(new RegExp('class="mceNonEditable"', 'g'), '')
            .replace(new RegExp('<hr class="page-break" />', 'g'), '')
            .replace(new RegExp('class="tab-space mceNonEditable" style="padding-left', 'g'), 'style="width');

       
        // .replace(new RegExp('<br />', 'g'), '<br>');
        const reportHtml = `<html><body>${reportSnippet}</body></html>`;

       // console.log(reportHtml);

        var docRequest = new DocumentRequest();
        docRequest.DocumentAsBase64String = window.btoa(reportHtml);
        docRequest.ReportId = this.props.match.params.jobid;
        docRequest.Account = this.props.match.params.account;
        if (updatePatientInfo === 1) {
            docRequest.PatientInfo = {
                PatientLast: self.state.patient.PatientLastName,
                PatientId: self.state.patient.PatientID,
                RefPhysician: self.state.patient.ReferringPhysician,
                Physician: self.state.patient.Physician,
                PatientFirst: self.state.patient.PatientFirstName,
                Procedure: self.state.patient.Procedure,
                AdmitDate: moment(self.state.patient.DateOfService).isValid() ? moment(self.state.patient.DateOfService).format('MM/DD/YYYY') : '',
                DateOfBirth: self.state.patient.DateOfBirth,
                CaseId: self.state.patient.CaseId,
                WorkType: self.state.patient.WorkType
            };
        }

        return docRequest;
    }

    saveDocument = (updatePatientInfo) => {
        
       
        let self = this;
        let docRequest = this.buildDocumentRequest(updatePatientInfo);

        dataAccess.saveReport(docRequest).then(
            function (reportData) {
                self.setState({ openSnack: true, snackMessage: "Report saved" });
                self.loadReportDoc();
                self.refreshReportDetail();
            });


    };

    handlePatientChange = name => event => {

        var patient = this.state.patient;
        patient[name] = event.target.value;

        this.setState({
            patient
        });
    };

    handleChange = name => event => {

        this.setState({
            [name]: event.target.value
        });
    };

    handlePatientCheckBoxChange = name => event => {

        var patient = this.state.patient;
        patient[name] = event.target.checked;

        this.setState({
            patient
        }, this.savePatientInfo());


    };

    savePatientInfo = () => {

        var self = this;
        dataAccess.saveReportInfo(this.state.patient).then(function (rs) {
            self.setState({ openSnack: true, snackMessage: "Report saved" });
        });
    }

    reassignPatientInfo = () => {

        var self = this;

        var patient = this.state.patient;

  

        patient.AdmitDate = this.state.reassignPatientList[this.state.selectedNewPatient].DateOfService;
        patient.CaseId = this.state.reassignPatientList[this.state.selectedNewPatient].CaseId;
        patient.DateOfService = this.state.reassignPatientList[this.state.selectedNewPatient].DateOfService;
        patient.DateOfBirth = this.state.reassignPatientList[this.state.selectedNewPatient].DateOfBirth;
        patient.PatientFirstName = this.state.reassignPatientList[this.state.selectedNewPatient].PatientFirstName;
        patient.PatientID = this.state.reassignPatientList[this.state.selectedNewPatient].AppointmentInfo.PatientId;
        patient.PatientLastName = this.state.reassignPatientList[this.state.selectedNewPatient].PatientLastName;
        patient.Physician = this.state.reassignPatientList[this.state.selectedNewPatient].PrimaryPhysician;
        patient.Procedure = this.state.reassignPatientList[this.state.selectedNewPatient].Procedure;
        patient.ReferringPhysician = this.state.reassignPatientList[this.state.selectedNewPatient].ReferringPhysician;
        self.setState({ patient: patient, reassignPatient: false }, this.updatePatientInfo);

        ReactGA.event({
            action: 'ReportEdit',
            category: 'ReassignPatientInfo',
            label: auth.getUserType()
        });


    }

    updatePatientInfo = () => {

        var self = this;
        
        dataAccess.saveReportInfo(this.state.patient).then(function (rs) {
            self.saveDocument(1);
        });

    }

    handleCheckBoxChange = name => event => {

        this.setState({
            [name]: event.target.checked
        });

    };

    onCancel = () => {
        this.props.history.goBack();
    }



    onSignReport = () => {
        var self = this;
        if (!self.state.patient.HasValidSignature) {

            self.setState({ showWarning: true, warningText: (<div>Signature not found on file. Download the mobile app or <a href={esignDoc} target='_blank' rel='noopener noreferrer'>E-Signature forms</a> to submit a signature.</div>) })
        }
        else if (self.state.patient.Comments && self.state.patient.Comments.length > 0) {
            self.setState({ showSignWarning: true });
        }
        else {
            self.signReport()
        }
    }

    signReport = async () => {

        var self = this;
        var promiseSave = null;
        self.setState({ showProgressIndicator: true, progressTitle: "Signing Report..." });

        if (this.state.reportChanged) {
            let docRequest = self.buildDocumentRequest();

            promiseSave = dataAccess.saveReport(docRequest);
        }
        else {
            promiseSave = new Promise((resolve) => { resolve(true); });
        }

        promiseSave.then(
            async function () {
                if (self.state.patient.ParentJobId > 0) {
                    const result = await self.stitchParent();
                    if (!result) {
                        self.setState({ showProgressIndicator: false, openSnack: true, snackMessage: "Addendum failed to stitch" });
                        return;
                    }
                }
                dataAccess.signReports({ "Account": self.props.match.params.account, "SignatureRequestItems": [{ "ReportId": self.props.match.params.jobid, "DictatorId": self.state.patient.DictatorId }] })
                    .then(function () {
                        self.setState({ showProgressIndicator: false, openSnack: true, snackMessage: "Report signed" });
                        self.loadReport();
                    })
                    .then(() => {
                        if (self.checkNextReport()) {
                            self.navigateNext(null, true);
                        }
                        else {
                            self.loadReportDoc();
                            self.refreshReportDetail()
                        }
                });
            }
        );
    };

    refreshReportDetail = () => {

        var self = this;
        dataAccess.getReportDetailById(self.props.match.params.jobid, self.props.match.params.account).then(
            function (patientData) {

                self.setState({ patient: patientData });

            });

    };

    loadReportDoc = () => {

        return new Promise((resolve, reject) => {
        var self = this;
       
        dataAccess.getReportById(self.props.match.params.account, self.props.match.params.jobid).then(
            function (reportData) {
              
                let font = "Courier New";
                let fontSize = "12pt";

                try {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(reportData, "text/html");
                    if (doc && doc.body && doc.body.style) {

                        font = doc.body.style.fontFamily;
                        fontSize = doc.body.style.fontSize;
                    }
                } catch (e) {}

               
                const formattedReport = reportData.replace('<div style="-aw-different-first-page', '<div class="mceNonEditable" style="-aw-different-first-page')

                    .replace(new RegExp("maxlength=", 'g'), "size=")
                    .replace(new RegExp("<input ", 'g'), "<input readOnly ")
                    .replace(new RegExp('<br style="page-break-before:always', 'g'), '<hr class="page-break" /><br style="page-break-before: always')
                    .replace(new RegExp('style="width:(.*?|\n); display:inline-block', 'g'), 'class="tab-space mceNonEditable" style="padding-left: $1; display: inline-block');

                  //  .replace("<div id='signature'", '<div id=\'signature\' class="mceNonEditable"');
                    
                   /* .replace("</html>", "")
                    .replace("<html>", "")
                    .replace("<body>", "")
                    .replace("</body>", "");*/
                // .replace("<p>TEST</p>",'<img src="data:image/gif;base64,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">');
                self.setState({
                    report: formattedReport,
                    //reportHtml: formattedReport,
                    reportChanged: false, font: font, fontSize: fontSize
                }, () => resolve(true));

            });
        });
    };

    onSaveEditPatientData = async () => {
        if(!await this.validatePatientId()) {
            this.setState({ patientIdInvalid: true });
            return;
        }
        let patient = this.state.patient;
        patient.DateOfService = patient.AdmitDate;
        this.setState({ editPatientData: false, patient, patientIdInvalid: false }, this.onSaveReportInfo(1));

        ReactGA.event({
            action: 'ReportEdit',
            category: 'EditPatientData',
            label: auth.getUserType()
        });
    }

    onSaveReportInfo = (updateProps) => {

        var self = this;
        dataAccess.saveReportInfo(self.state.patient).then(function (rs) {
            self.saveDocument(updateProps);
        });

        ReactGA.event({
            action: 'ReportEdit',
            category: 'Save',
            label: auth.getUserType()
        });

    }

    handleAuditClose = () => {

        this.setState({
            openAudit: false
        });
    }

    sendDistribution = () => {
        var self = this;
        self.setState({ sendingDistribution: true })
        dataAccess.distributeReport({ "Report": this.state.patient, "Name": this.state.distributionName, "Address": this.state.distributionAddress, "SaveAddress": this.state.distributionSaveAddress }).then(function (rs) {
            self.setState({ openSnack: true, snackMessage: "Report distribution submitted", sendingDistribution: false, distributionName: "", distributionAddress: "" });
        });
    }

    handleDistHistClose = () => {

        this.setState({
            openDistHist: false
        });
    }

    handleDistHistOpen = () => {

        var self = this;
        self.setState({
            loadingDistribution: true
        });
        dataAccess.getDistributionDetails(this.props.match.params.account, this.state.patient.JobId).then(function (result) {

            self.setState({
                distHistory: result, loadingDistribution: false
            });
        });

        this.setState({
            openDistHist: true
        });


    }

    handleAuditOpen = () => {

        var self = this;
        self.setState({
            loadingAudit: true, anchorElExtended: null
        });

        dataAccess.getAuditDetails(this.props.match.params.account, this.state.patient.JobId).then(function (result) {

            self.setState({
                auditDetails: result,
                loadingAudit: false
            });
        });

        this.setState({
            openAudit: true
        });
    }

    handleSnackClose = () => {
        this.setState({ openSnack: false, snackMessage: "" });
    };

    handleCreateAddendumPrompt = () => {
        this.setState({
            showAlert: true, alert: {
                alertText: "Are you sure you want to create an addendum? This will create a new job.",
                alertOkText: "CREATE",
                alertCancelText: "CANCEL",
                alertTitle: "Create Addendum",
                onAlertOk: () => {
                    this.handleCreateAddendum();
                    this.setState({ showAlert: false });
                },
                onAlertCancel: () => {
                    this.setState({ showAlert: false });
                },
                component: null
            }})
    }

    handleCreateAddendum = async () => {

        var addendumReportId;
        let self = this;
        const patientInfo = {
            PatientLast: self.state.patient.PatientLastName,
            PatientId: self.state.patient.PatientID,
            RefPhysician: self.state.patient.ReferringPhysician,
            Physician: self.state.patient.Physician,
            PatientFirst: self.state.patient.PatientFirstName,
            Procedure: self.state.patient.Procedure,
            AdmitDate: moment(self.state.patient.DateOfService).isValid() ? moment(self.state.patient.DateOfService).format('MM/DD/YYYY') : '',
            DateOfBirth: self.state.patient.DateOfBirth,
            CaseId: self.state.patient.CaseId,
            WorkType: self.state.patient.WorkType
        };
        dataAccess.createAddendum(this.state.patient.Account, this.state.patient.Id, patientInfo)
            .then((result) => {

                if (result.data.ReportId === 0) {
                    this.setState({
                        showAlert: true, alert: {
                            alertText: "",
                            alertOkText: "OK",
                            alertCancelText: null,
                            alertTitle: "Addendum Unavailable",
                            onAlertOk: () => {
                                this.setState({ showAlert: false });
                            },
                            onAlertCancel: null,
                            component: <Typography variant="subtitle">Unable to create addendum. Please call <a href="tel: 800 - 459 - 5616">800-459-5616</a> or email <a href="mailto: acctmgrs@surgicalnotes.com">acctmgrs@surgicalnotes.com</a> to setup</Typography>
                        }
                    })
                    return;
                }
                addendumReportId = result.data.ReportId;
                this.props.history.push({
                    pathname: `/reportDetails/${this.state.patient.Account}/${addendumReportId}/addendum`,
                    state: { selectedJobs: ['7459135', '7459135'] }
                });

                userDataAccess.writeAudit({
                    JobId: self.state.patient.JobId,
                    Message: `Addendum Created by: ${auth.getUserId()}`
                });
            })
            .catch(error => {});

        
    }

    onInProgressClose = () => {
        this.props.history.goBack();
    };

    onCloseWarning = () => {

        this.setState({
            showWarning: false,
            warningTitle: "",
            warningText: ""
        });
    };

    onConfirmSign = () => {

        this.setState({
            confirmedSign: true,
            showSignWarning: false
        });
        this.signReport();
    };

    onCancelSign = () => {

        this.setState({
            confirmedSign: true,
            showSignWarning: false
        });
    };

    onClearIssue = () => {

        var self = this;

        dataAccess.clearComments(this.props.match.params.account, this.props.match.params.jobid).then(function (result) {

            self.setState({ openSnack: true, snackMessage: "Issue Cleared" });
            self.refreshReportDetail();

        });
    };

    unsignReport = () => {
        var self = this;

        dataAccess.unsignReport(this.props.match.params.account, this.props.match.params.jobid).then(function (result) {

            self.setState({ openSnack: true, snackMessage: "Report Unlocked" });
            self.refreshReportDetail();

        });
    };

    onReassignClose = () => {
        this.setState({ reassignPatient: false });
    }

    onEditPatientClose = () => {
        this.setState({ editPatientData: false });
    }

    onDateFilterChange = (e, filterName) => {
        this.setState({ [filterName]: e.target.value });
    }

    handleScheduleDateChange = (date) => {

        this.setState({ scheduleDate: date });
        if (moment(date).isValid()) {
            this.setState({ scheduleDateInput: moment(date).format("MM/DD/YYYY") }, this.loadReassignPatientList);

        }
    }

    stitchParent = async () => {
        let self = this;
        self.setState({ showProgressIndicator: true, progressTitle: "Stitching Report..." });

        let safeHtml = unescape(encodeURIComponent(self.state.reportHtml));
        const reportSnippet = safeHtml.replace(new RegExp('class="mceNonEditable"', 'g'), '')
            .replace(new RegExp('<hr class="page-break" />', 'g'), '')
            .replace(new RegExp('class="tab-space mceNonEditable" style="padding-left', 'g'), 'style="width');
        const reportHtml = `<html><body>${reportSnippet}</body></html>`;
        let reportString = window.btoa(reportHtml);

        try { 
            const response = await dataAccess.sitchParentReport(self.state.patient.Account, self.state.patient.Id, self.state.patient.ParentJobId, reportString)
            if (response.data) {
                self.setState({ showProgressIndicator: false, openSnack: true, snackMessage: "Report stitched" });
                return true;
            }
            else {
                self.setState({ showProgressIndicator: false, openSnack: true, snackMessage: "Error Stitching Report" });
                return false;
            }
        }
        catch (error) {
            self.setState({ showProgressIndicator: false, openSnack: true, snackMessage: "Error Stitching Report" });
            return false;
        }
        
    }

    loadReassignPatientList = () => {

        var self = this;
        self.setState({ loadingResassignPatients: true, reassignPatientList: [], selectedNewPatient: '' });
        scheduleAccess.search({
            "FromDate": this.state.scheduleDateInput,
            "ToDate": moment(this.state.scheduleDateInput).add(1, 'd').format('MM/DD/YYYY'),
            "Account": auth.getActiveAccount(),
            "DictatorId": auth.getDictatorId(),
        }).then(function (data) {

            self.setState({ reassignPatientList: data, loadingResassignPatients: false });
        });

    }

    openEditPatient = () => {
        this.setState({ editPatientData: true, anchorElExtended: null });
    }

    openReassignPatient = () => {

        this.loadReassignPatientList();
        this.setState({ reassignPatient: true, anchorElExtended: null });

    }

    sortPatient = (ob1, ob2) => {
        if (ob1.PatientLastName > ob2.PatientLastName) {
            return 1;
        } else if (ob1.PatientLastName < ob2.PatientLastName) {
            return -1;
        }

        // Else go to the 2nd item
        if (ob1.PatientFirstName < ob2.PatientFirstName) {
            return -1;
        } else if (ob1.PatientFirstName > ob2.PatientFirstName) {
            return 1
        } else { // nothing to split them
            return 0;
        }
    }

    validatePatientId = () => {
        return dataAccess.validatePatientData(
            {
                Account: this.state.patient.Account,
                PatientId: this.state.patient.PatientID,
                PatientInfoId: this.state.patient.PatientInfoId,
                FirstName: this.state.patient.PatientFirstName,
                LastName: this.state.patient.PatientLastName
            }
        ).then(response => {
            if (response.length > 0) {
                return false;
            }
            return true;
        }).catch(error => {
            return false;
        });
    }


    render() {

        const { classes } = this.props;
        const { anchorEl, anchorElExtended, auditDetails, distHistory, openSnack, snackMessage, showProgressIndicator, progressTitle, progressText} = this.state;

        return (
            <div>
                <Card>
                    <CardHeader
                        title={`Report Details: ${this.state.patient.JobId}`}
                    />
                    <CardContent>
                        <ProgressIndicator showProgressIndicator={showProgressIndicator} progressTitle={progressTitle} progressText={progressText} />
                        <Snackbar
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            open={openSnack}
                            autoHideDuration={3000}
                            onClose={this.handleSnackClose}
                            ContentProps={{
                                'aria-describedby': 'message-id',
                            }}
                            message={<span id="message-id">{snackMessage}</span>}
                        />
                        <Dialog onClose={this.onCancelSign} open={this.state.showSignWarning} aria-labelledby="simple-dialog-title">
                            <DialogTitle id="simple-dialog-title">Confirm Comment Addressed</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    The report has a comment, by selecting 'OK' you confirm the comment has been addressed.  Otherwise, click 'Cancel' to view the comment.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.onConfirmSign} color="primary">
                                    Ok
                                </Button>
                                <Button onClick={this.onCancelSign} color="primary">
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog onClose={this.onCloseWarning} open={this.state.showWarning} aria-labelledby="simple-dialog-title">
                            <DialogTitle id="simple-dialog-title">{this.state.warningTitle}</DialogTitle>
                            <DialogContent>
                                <DialogContentText component="div">
                                    {this.state.warningText}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.onCloseWarning} color="primary">
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog onClose={this.onInProgressClose} open={this.state.patient.OverallStatus === 'InProgress'} aria-labelledby="simple-dialog-title">
                            <DialogTitle id="simple-dialog-title">In Progress</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Document is currently being typed. Please check back later.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.onInProgressClose} color="primary">
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog onClose={this.onEditPatientClose} open={this.state.editPatientData} aria-labelledby="edit-patient-dialog-title" fullWidth>
                            <DialogTitle id="edit-patient-dialog-title">Edit Patient Data</DialogTitle>
                            <DialogContent>
                                <Grid container spacing={3}>

                                    <Grid item xs={6}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    id="fName"
                                                    label="First"
                                                    className={classes.textField}
                                                    margin="normal"
                                                    value={this.state.patient.PatientFirstName}
                                                    onChange={this.handlePatientChange('PatientFirstName')}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    id="lName"
                                                    label="Last"
                                                    className={classes.textField}
                                                    margin="normal"
                                                    value={this.state.patient.PatientLastName}
                                                    onChange={this.handlePatientChange('PatientLastName')}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    required
                                                    label="Patient ID"
                                                    className={classes.textField}
                                                    value={this.state.patient.PatientID}
                                                    error={this.state.patient.PatientID.length <= 0 || this.state.patientIdInvalid}
                                                    helperText={this.state.patientIdInvalid ? "already in use" : ""}
                                                    onChange={this.handlePatientChange('PatientID')}
                                                    margin="normal"
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    required
                                                    label="Case ID"
                                                    className={classes.textField}
                                                    error={this.state.patient.CaseId.length <= 0}
                                                    value={this.state.patient.CaseId}
                                                    onChange={this.handlePatientChange('CaseId')}
                                                    margin="normal"
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    required
                                                    label="Date of Birth"
                                                    className={classes.textField}
                                                    error={this.state.patient.DateOfBirth.length <= 0}
                                                    value={this.state.patient.DateOfBirth}
                                                    onChange={this.handlePatientChange('DateOfBirth')}
                                                    margin="normal"
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    required
                                                    label="Date of Service"
                                                    error={this.state.patient.AdmitDate.length <= 0}
                                                    className={classes.textField}
                                                    value={this.state.patient.AdmitDate}
                                                    onChange={this.handlePatientChange('AdmitDate')}
                                                    margin="normal"
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    label="Procedure"
                                                    className={classes.textField}
                                                    value={this.state.patient.Procedure}
                                                    onChange={this.handlePatientChange('Procedure')}
                                                    margin="normal"
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    label="Referring Physician"
                                                    className={classes.textField}
                                                    value={this.state.patient.ReferringPhysician}
                                                    onChange={this.handlePatientChange('ReferringPhysician')}
                                                    margin="normal"
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.onSaveEditPatientData} disabled={this.state.patient.AdmitDate.length <= 0 || this.state.patient.CaseId.length <= 0 || this.state.patient.PatientID.length <= 0 || this.state.patient.DateOfBirth.length <= 0 } color="primary" variant="contained">
                                    Save
                                </Button>
                                <Button onClick={this.onEditPatientClose} color="primary">
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog onClose={this.onReassignClose} open={this.state.reassignPatient} aria-labelledby="simple-dialog-title" PaperProps={{ style: { overflow: 'visible' } }} fullWidth>
                            <DialogTitle id="simple-dialog-title">Re-assign Patient</DialogTitle>
                            <DialogContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <div className={classes.datePicker}>
                                            <DatePicker
                                                disabledKeyboardNavigation
                                                onChange={this.handleScheduleDateChange}
                                                selected={this.state.scheduleDate}
                                                customInput={<div><TextField
                                                    fullWidth
                                                    id="scheduleDate"
                                                    label="Date of Service"
                                                    value={this.state.scheduleDateInput}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    onChange={(e) => this.onDateFilterChange(e, 'scheduleDateInput')}
                                                /></div>} />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className={classes.wrapper}>
                                            <FormControl className={classes.formControl} fullWidth disabled={this.state.loadingResassignPatients}>
                                                <InputLabel htmlFor="patient-select">Patient</InputLabel>
                                                <NativeSelect
                                                    value={this.state.selectedNewPatient}
                                                    onChange={this.handleChange('selectedNewPatient')}
                                                    inputProps={{
                                                        name: 'patient-select',
                                                        id: 'patient-select',
                                                    }}

                                                >
                                                    <option value=""></option>
                                                    {
                                                        this.state.reassignPatientList.sort(this.sortPatient).map(function (a, index) {
                                                            return <option key={a.Id} value={index}>{a.PatientLastName + ', ' + a.PatientFirstName + ' (' + a.AppointmentInfo.PatientId + ')'}</option>;

                                                        })
                                                    }

                                                </NativeSelect>
                                                <FormHelperText>Select a patient from the schedule</FormHelperText>
                                            </FormControl>
                                            {this.state.loadingResassignPatients && <CircularProgress size={24} className={classes.buttonProgress} />}
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <DialogContentText>
                                            Patient Id: {(this.state.selectedNewPatient !== '') && this.state.reassignPatientList[this.state.selectedNewPatient].AppointmentInfo.PatientId}<br />
                                            Date of birth: {(this.state.selectedNewPatient !== '') && this.state.reassignPatientList[this.state.selectedNewPatient].DateOfBirth}<br />
                                            Referring Physician: {(this.state.selectedNewPatient !== '') && this.state.reassignPatientList[this.state.selectedNewPatient].ReferringPhysician}<br />
                                            Procedure: {(this.state.selectedNewPatient !== '') && this.state.reassignPatientList[this.state.selectedNewPatient].Procedure}<br />
                                            Case Id:  {(this.state.selectedNewPatient !== '') && this.state.reassignPatientList[this.state.selectedNewPatient].CaseId}<br />
                                        </DialogContentText>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.reassignPatientInfo} color="primary" variant="contained" disabled={this.state.selectedNewPatient === ''}>
                                    Select and Re-assign
                                </Button>
                                <Button onClick={this.onReassignClose} color="primary">
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog onClose={this.handleAuditClose} open={this.state.openAudit} aria-labelledby="simple-dialog-title">
                            <DialogTitle id="simple-dialog-title">Audit Log</DialogTitle>
                            <DialogContent>

                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Id</TableCell>
                                            <TableCell>Audit</TableCell>
                                            <TableCell>Date</TableCell>
                                            <TableCell>User</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.loadingAudit && <TableRow><TableCell colSpan={4}><CircularProgress /></TableCell></TableRow>}
                                        {(!this.state.loadingAudit && auditDetails) && auditDetails.map(n => {
                                            return (
                                                <TableRow key={n.Id}>
                                                    <TableCell component="th" scope="row">
                                                        {n.Id}
                                                    </TableCell>
                                                    <TableCell>{n.Audit}</TableCell>
                                                    <TableCell>{n.Date}</TableCell>
                                                    <TableCell>{n.UserId}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleAuditClose} color="primary">
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog onClose={this.handleDistHistClose} open={this.state.openDistHist} aria-labelledby="simple-dialog-title">
                            <DialogTitle id="simple-dialog-title">Distribution</DialogTitle>
                            <DialogContent>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Fax</TableCell>
                                            <TableCell>Date</TableCell>
                                            <TableCell>Send to</TableCell>
                                            <TableCell>Status</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.loadingDistribution && <TableRow><TableCell colSpan={4}><CircularProgress /></TableCell></TableRow>}
                                        {(!this.state.loadingDistribution && distHistory) && distHistory.map(n => {
                                            return (
                                                <TableRow key={n.FaxDate}>
                                                    <TableCell component="th" scope="row">
                                                        {n.Fax}
                                                    </TableCell>
                                                    <TableCell>{n.FaxDate}</TableCell>
                                                    <TableCell>{n.SendTo}</TableCell>
                                                    <TableCell>{n.Status}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>


                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleDistHistClose} color="primary">
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Grid container spacing={2}>
                            <Grid item md={8} sm={12} xs={12}>
                                <Paper className={classes.paper}>
                                    <Grid container spacing={0} justify="space-between">
                                        <Grid item>

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value="printed"
                                                        checked={this.state.patient.Printed}
                                                        onChange={this.handlePatientCheckBoxChange('Printed')}
                                                    />
                                                }
                                                label="Printed"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value="downloaded"
                                                        checked={this.state.patient.Downloaded}
                                                        onChange={this.handlePatientCheckBoxChange('Downloaded')}
                                                    />
                                                }
                                                label="Downloaded"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value="archived"
                                                        checked={this.state.patient.Archived}
                                                        onChange={this.handlePatientCheckBoxChange('Archived')}
                                                        disabled={!auth.isInRole('Archive')}
                                                    />
                                                }
                                                label="Archived"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value="read"
                                                        checked={this.state.patient.Read}
                                                        onChange={this.handlePatientCheckBoxChange('Read')}
                                                        disabled={!auth.isInRole('MarkRead')}
                                                    />
                                                }
                                                label="Read"
                                            />

                                        </Grid>
                                        <Grid item >
                                            <Grid container spacing={0} alignItems="center">

                                                <Grid item style={{ marginRight: 4 }}>
                                                    <Button onClick={this.navigateNext} variant="contained" color="primary" size="small" disabled={this.state.selectedJobs.length <= 1}>
                                                        Next
                                                    </Button>
                                                </Grid>
                                                <Grid item style={{ marginRight: 4 }}>
                                                    <Button variant="contained" color="primary" size="small"
                                                        aria-owns={this.anchorEl ? 'download-options' : null}
                                                        aria-haspopup="true"
                                                        onClick={this.onOpenMenu}>
                                                        Download ...
                                                    </Button>
                                                    <Menu id="download-options"
                                                        anchorEl={anchorEl}
                                                        open={Boolean(anchorEl)}
                                                        onClose={this.onCloseMenu}>
                                                        <MenuItem key="word" onClick={(e) => this.onSelectDownloadOption(e, 'Doc')}>Word</MenuItem>
                                                        <MenuItem key="pdf" onClick={(e) => this.onSelectDownloadOption(e, 'Pdf')}>Pdf</MenuItem>
                                                    </Menu>
                                                </Grid>
                                                <Grid item style={{ marginRight: 4 }}>
                                                    <Button size="small" variant="contained" onClick={this.onSignReport} color="primary" disabled={this.state.patient.ESigned || !auth.isInRole('Sign') || (this.state.patient.ParentJobId > 0 && !this.state.reportChanged)}>E-Sign</Button>
                                                </Grid>
                                                <Grid item style={{ marginRight: 4 }}>
                                                    <Button size="small" className="MuiButton-containedSecondary" disabled={!this.state.patient.ESigned} onClick={this.handleCreateAddendumPrompt}>
                                                        Create Addendum
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <IconButton aria-label="More" variant="contained" color="primary"
                                                        aria-owns={this.anchorElExtended ? 'extended-options' : null}
                                                        aria-haspopup="true"
                                                        onClick={this.onOpenMenuExtended}>

                                                        <MoreIcon />
                                                    </IconButton>
                                                    <Menu id="extended-options"
                                                        anchorEl={anchorElExtended}
                                                        open={Boolean(anchorElExtended)}
                                                        onClose={this.onCloseMenuExtended}>

                                                        <MenuItem key="audit" onClick={this.handleAuditOpen}>Audit Log</MenuItem>
                                                        <MenuItem key="assignPatient" onClick={this.openReassignPatient} disabled={this.state.patient.ESigned || !auth.isInRole('Save')}>Re-assign Patient</MenuItem>
                                                        <MenuItem key="editPatientData" onClick={this.openEditPatient} disabled={this.state.patient.ESigned || !auth.isInRole('Save')}>Edit Patient Data</MenuItem>
                                                        {auth.isInRole('Admin') && <MenuItem key="unsignReport" onClick={this.unsignReport} disabled={!this.state.patient.ESigned || !this.state.unlockSignature}>Unlock Report</MenuItem>}
                                                    </Menu>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            {(this.state.patient.Comments && this.state.patient.Comments.length > 0) &&
                                                <div>
                                                 <Grid container spacing={2} alignItems="center" alignContent="flex-end">
                                                    <Grid item xs>
                                                        <SnackbarContent className={classes.issueSnack}

                                                            message={
                                                                <div>
                                                                    <WarningIcon style={{ fontSize: 20, opacity: 0.9, marginRight: 8, marginBottom: -5 }} />
                                                                    {this.state.patient.Comments}
                                                                </div>

                                                            }
                                                            action={<Button variant="outlined" onClick={this.onClearIssue} disabled={!auth.isInRole('Save')} className={classes.issueSnackButton}>Clear Issue</Button>}

                                                        />
                                                    </Grid>
                                                </Grid><br /></div>}
                                            {this.state.patient.ParentJobId > 0 &&
                                                <div>
                                                <Grid container spacing={2} >
                                                    <Grid item xs>
                                                        <SnackbarContent className={classes.addendumSnack}
                                                            message={
                                                                <div>
                                                                    {"ADDENDUM"}
                                                                </div>
                                                            }
                                                            action={
                                                                <Button variant="outlined" className={classes.issueSnackButton} onClick={this.handleGoToParent}>Go To Parent Job</Button>
                                                            }
                                                        />
                                                    </Grid>
                                                </Grid><br /></div>
                                            }
                                            {this.state.patient.ChildJobs && this.state.patient.ChildJobs.length > 0 &&

                                                <Accordion className={ classes.addendumSnack}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1a-content"
                                                        id="panel1a-header"
                                                    >
                                                        <WarningIcon style={{ fontSize: 20, opacity: 0.9, marginRight: 8, marginBottom: -5, color: "white" }} />
                                                        <Typography className={classes.heading}>ADDENDUMS</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Grid container spacing={1} >
                                                            {this.state.patient.ChildJobs.map((job, index) => {
                                                                return (
                                                                    <Grid item xs={ 12 }>
                                                                            <SnackbarContent key={job.ChildReportId} className={classes.addendumSnack}
                                                                                    message={
                                                                                        <div>
                                                                                            {`JobId: ${job.JobId}`}
                                                                                        </div>
                                                                                    }
                                                                                    action={
                                                                                        <Button variant="outlined" className={classes.issueSnackButton} onClick={(event) => { this.handleGotToAddendum(event, job.ChildReportId) }}>Go to Addendum</Button>
                                                                                    }
                                                                            />
                                                                        </Grid>
                                                                    );
                                                                }
                                                             )}
                                                        </Grid><br />
                                                    </AccordionDetails>
                                                </Accordion>
                                            }
                                            <RichTextEditor fontSize={this.state.fontSize} font={this.state.font} reportData={this.state.report} onEditorChange={this.handleEditorChange} />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item md={4} sm={12} xs={12}>
                                <Paper className={classes.paper}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1">
                                                Distribution
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <IntegrationAutosuggest suggestions={this.state.suggestions} placeholder={'Name of Recipient'} onSuggestionSelected={this.onSuggestionSelected} onInputChanged={this.onSuggestedInputChanged} />
                                        </Grid>
                                        <Grid item xs={12}>

                                            <TextField
                                                label="Fax or Email"
                                                className={classes.textField}
                                                margin="normal"
                                                value={this.state.distributionAddress}
                                                onChange={this.handleChange('distributionAddress')}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value="distributionSaveAddress"
                                                        checked={this.state.distributionSaveAddress}
                                                        onChange={this.handleCheckBoxChange('distributionSaveAddress')}
                                                    />
                                                }
                                                label="Add to Address Book"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container spacing={3} justify='flex-end'>
                                                <Grid item>
                                                    <Button variant="contained" className={classes.distButton} onClick={this.handleDistHistOpen}>View History</Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button variant="contained" className={classes.distButton} onClick={this.sendDistribution} disabled={this.state.distributionAddress === '' || this.state.distributionName === '' || this.state.sendingDistribution}>Send</Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                        </Grid>
                        <Fab variant="extended" className={classes.fab} onClick={this.onSaveReportInfo} disabled={(this.state.patient.ESigned || !auth.isInRole('Save')) || !this.state.reportChanged} color="secondary">
                            <SaveIcon className={classes.extendedIcon} />
                            Save
                        </Fab>
                    </CardContent>
                </Card>
                <Alert
                    showAlert={this.state.showAlert}
                    alertOkText={this.state.alert.alertOkText }
                    alertCancelText={this.state.alert.alertCancelText }
                    alertText={ this.state.alert.alertText}
                    alertTitle={this.state.alert.alertTitle }
                    onAlertOk={this.state.alert.onAlertOk}
                    onAlertCancel={this.state.alert.onAlertCancel}
                >{ this.state.alert.component}</Alert>
            </div>
        );
    }
}

//export default withStyles(styles)(ReportDetails);
export default compose(withRouter, withStyles(styles, { withTheme: true }))(ReportDetails);